import { useCallback } from 'react';
import cross from '~/assets/icons/cross.svg';
import { playSound, Sound } from '~/assets/sounds';
import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import { rage, useInputAction, useObservable } from '~/rage';
import { InputAction } from '~/shared';
import {
	setModalChangeNameRejectedVisible,
	setModalChangeNameVisible,
	useLayoutDispatch,
} from '../../redux';
import {
	StyledContainer,
	StyledGrid,
	StyledHeadContainer,
	StyledNicknameSummary,
	StyledReasonContainer,
} from '../ModalChangeName/ModalChangeName.styled';

const ModalChangeNameRejectedPanel = () => {
	const dispatch = useLayoutDispatch();
	const application = useObservable(rage.donate.getChangeNameApplication());

	const close = useCallback(() => {
		dispatch(setModalChangeNameRejectedVisible(false));
	}, [dispatch]);

	const handleTryAgain = useCallback(() => {
		playSound(Sound.ClickButton);
		dispatch(setModalChangeNameRejectedVisible(false));
		dispatch(setModalChangeNameVisible(true));
	}, [dispatch]);

	useInputAction(InputAction.CommonMenuClose, close);

	if (!application || application.status !== 'rejected') {
		return null;
	}

	return (
		<StyledContainer>
			<StyledHeadContainer>
				<Text>Смена никнейма</Text>
				<Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height20}
					borderRadius={ButtonBorderRadius.Radius5}
					style={{ width: 20 }}
					onClick={() => {
						close();
						playSound(Sound.ClickButton);
					}}
				>
					<img src={cross} width={10} height={10} />
				</Button>
			</StyledHeadContainer>
			<Divider
				$direction={'H'}
				style={{ marginTop: 30, marginBottom: 30, opacity: 0.1 }}
			/>
			<Text style={{ fontSize: 16, color: '#ffffff', opacity: 0.75 }}>
				К сожалению, но ваша заявка на смену никнейма была отклонена.
			</Text>

			<StyledNicknameSummary>
				<Text>Никнейм</Text>
				<Text>{`${application.firstName} ${application.lastName}`.trim()}</Text>
			</StyledNicknameSummary>
			{application.reason && (
				<StyledReasonContainer>
					<Text>Причина</Text>
					<Text>{application.reason}</Text>
				</StyledReasonContainer>
			)}
			<Divider
				$direction={'H'}
				style={{ marginTop: 20, marginBottom: 30, opacity: 0.1 }}
			/>
			<StyledGrid style={{ gap: 20, marginTop: 0 }}>
				<Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height50}
					onClick={() => {
						close();
						playSound(Sound.ClickButton);
					}}
				>
					<Text>Закрыть окно</Text>
				</Button>
				<Button
					color={ButtonColors.Select}
					height={ButtonHeight.Height50}
					onClick={handleTryAgain}
				>
					<Text>Выбрать никнейм</Text>
				</Button>
			</StyledGrid>
		</StyledContainer>
	);
};

export { ModalChangeNameRejectedPanel };
